export default __webpack_public_path__ + "static/media/9 a.b674bc8c.png";